<template>
  <div>
    <div class="text-left">
      <div class="mb-8 flex justify-between">
        <div v-if="firstTime">
          <h4 class="mb-2 text-dark-blue">
            Select the states in which you run.
          </h4>
          <p class="text-body-color">Click to select</p>
        </div>
        <div v-else>
          <h4 class="my-3 text-dark-blue">
            Please confirm the regions in which you run.
          </h4>
          <div class="flex">
            <div class="mr-6">
              <label class="text-2xs font-bold text-gray-over-dark"
                >RUNS IN CANADA</label
              >
              <p class="text-dark-gray">
                {{ canada ? 'Yes' : 'No' }}
              </p>
            </div>
            <div>
              <label class="text-2xs font-bold text-gray-over-dark"
                >RUNS IN MEXICO</label
              >
              <p class="text-dark-gray">
                {{ mexico ? 'Yes' : 'No' }}
              </p>
            </div>
          </div>
        </div>
        <div class="flex flex-col rounded-md border border-light-gray p-2">
          <div class="flex">
            <p class="mr-2 text-2xs font-bold capitalize text-dark-blue">
              INSPECTIONS
            </p>
            <p class="text-2xs font-bold text-body-color">LAST 24 MOS</p>
          </div>
          <div class="my-2 flex items-center">
            <img
              src="@/assets/lanes/key_obs_desktop.svg"
              alt="observed key"
            />
            <p class="mx-2 text-body-color">Observed Inspections</p>
          </div>
          <div class="mb-2 flex items-center">
            <img
              src="@/assets/lanes/key_preferred.svg"
              alt="observed key"
              style="width: 24px; height: 24px"
            />
            <p class="mx-2 text-body-color">Preferred States</p>
          </div>
          <div class="flex items-center">
            <img
              src="@/assets/lanes/key_pref_observed.svg"
              alt="observed key"
              style="width: 24px; height: 24px"
            />
            <p class="mx-2 text-body-color">Preferred + Observed</p>
          </div>
        </div>
      </div>
      <us-regional-map
        id="us_regional_map_by_state"
        @mousemove="setMouseCoordinate($event)"
      />
      <div
        v-if="firstTime"
        class="mt-8 flex gap-8"
      >
        <div class="flex w-1/2 flex-col text-left">
          <label class="text-2xs font-bold text-gray-over-dark"
            >I RUN IN CANADA (REQUIRED)</label
          >
          <div class="mt-2">
            <yes-no
              :field="`lanes.countries.canada`"
              :yes-checked="typeof canada === 'boolean' && canada"
              :no-checked="typeof canada === 'boolean' && !canada"
              :handle-click="handleClickCanada"
              value="'canada'"
              :small-gap="true"
            />
          </div>
        </div>
        <div class="mb-2 flex w-1/2 flex-col text-left">
          <label class="text-2xs font-bold text-gray-over-dark"
            >I RUN IN MEXICO (REQUIRED)</label
          >
          <div class="mt-2">
            <yes-no
              :field="`lanes.countries.mexico`"
              :yes-checked="typeof mexico === 'boolean' && mexico"
              :no-checked="typeof mexico === 'boolean' && !mexico"
              :handle-click="handleClickMexico"
              value="'mexico'"
              :small-gap="true"
            />
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="hoveredState"
      class="state-tag-container"
      :style="mousePosCssVars"
    >
      <div
        id="state-tag"
        class="state-tag"
      >
        {{ stateName(hoveredState) }}
      </div>
    </div>
  </div>
</template>

<script>
import YesNoRadioButtons from '../../YesNoRadioButtons.vue';
import USRegionalMapByState from './Regions/USRegionalMapByState.vue';
import usStates from '@/common/usStates';

export default {
  name: 'LanesDesktop',
  components: {
    'yes-no': YesNoRadioButtons,
    'us-regional-map': USRegionalMapByState,
  },
  props: {
    data: Object,
    updateField: Function,
    title: String,
    firstTime: Boolean,
    handleError: Function,
    handleClickCanada: Function,
    handleClickMexico: Function,
    handleCountryError: Function,
    canada: [String, Boolean],
    mexico: [String, Boolean],
    regions: Array,
    addRegion: Function,
    removeRegion: Function,
    inspected: Array,
    preferred: Array,
    preferredByRegion: Object,
    addPreferred: Function,
    removePreferred: Function,
    addPreferredAndRegion: Function,
    removePreferredAndRegion: Function,
    screenSize: String,
    stepName: String,
    updateLanesPacket: Function,
  },
  data() {
    return {
      hoveredState: '',
      mouseX: '',
      mouseY: '',
      stateTagWidth: '',
      executed: false,
      dataAvailable: false,
      isMounted: false,
      docQuery: false,
    };
  },
  computed: {
    mousePosCssVars() {
      return {
        '--mouseX': this.mouseX + 'px',
        '--mouseY': this.mouseY + 'px',
        '--tagWidth': this.stateTagWidth + 'px',
      };
    },
  },
  watch: {
    stepName: function (val) {
      if (val === 'Lanes') {
        // this.handleLoad();
        let self = this;
        console.log('Lanes stepName watcher - preferred');
        console.dir(self.preferred);
        setTimeout(() => {
          if (document.querySelector('#us_regional_map_by_state')) {
            self.docQuery = true;
            console.log('preferred watcher2 - preferred');
            console.dir(self.preferred);
            self.handleLoad();
          }
        }, 50);
      }
    },
    firstTime(nv) {
      if (nv) this.handleLoad();
    },
    isMounted(nv) {
      if (nv && this.docQuery == false) {
        let self = this;
        console.log('isMounted watcher - preferred');
        console.dir(self.preferred);
        setTimeout(() => {
          if (document.querySelector('#us_regional_map_by_state')) {
            self.docQuery = true;
            console.log('isMounted watcher2 - preferred');
            console.dir(self.preferred);
            self.handleLoad();
          }
        }, 50);
      }
    },
    // preferred(nv) {
    //   if (nv && this.docQuery == false) {
    //     let self = this;
    //     console.log('preferred watcher - preferred');
    //     console.dir(self.preferred);
    //     setTimeout(() => {
    //       if (document.querySelector("#us_regional_map_by_state")) {
    //         self.docQuery = true;
    //         console.log('preferred watcher2 - preferred');
    //         console.dir(self.preferred);
    //         self.handleLoad();
    //       }
    //     }, 500);

    //   }
    // },
  },
  updated() {
    if (
      this.title === 'Lanes' &&
      !this.firstTime &&
      this.isMounted &&
      this.docQuery
    ) {
      const usStatesArray = this.setUsStatesArrayComputed();
      usStatesArray.map((el) => {
        el.classList.remove('state-hovered');
        el.replaceWith(el.cloneNode(true));
      });
    }
  },
  async mounted() {
    // this.setUsStatesArrayComputed();
    this.isMounted = true;
    if (this.stepName === 'Lanes') {
      if (document.querySelector('#us_regional_map_by_state')) {
        this.docQuery = true;
        this.handleLoad();
      }
    }
  },
  methods: {
    updateNestedField(path, value) {
      this.$store.commit('updateNestedField', { path, value });
    },
    handleStatesError() {
      this.handleError('selected', !this.preferred.length);
    },
    handleClick(e) {
      let el = e.currentTarget;
      let inspectedHash = e.currentTarget.inspectedHash;
      let stateCode = el.classList[2];

      let region = el.parentElement.dataset.name;
      switch (true) {
        case el.classList.contains('preferred-observed'):
          el.classList.remove('preferred-observed');
          el.classList.add('observed');
          this.removePreferredAndRegion(stateCode, region);
          break;
        case !el.classList.contains('preferred') &&
          inspectedHash[stateCode] !== undefined:
          el.classList.remove('state-hovered');
          el.classList.add('preferred-observed');
          this.addPreferredAndRegion(stateCode, region);
          this.addRegion(region);
          break;
        case !el.classList.contains('preferred'):
          el.classList.remove('state-hovered');
          el.classList.add('preferred');
          this.addPreferredAndRegion(stateCode, region);
          this.addRegion(region);
          break;
        default:
          el.classList.remove('preferred');
          this.removePreferredAndRegion(stateCode, region);
          break;
      }
      this.handleStatesError();
    },
    stateName(stateCode) {
      if (!this.hoveredState) return;
      return usStates?.[stateCode]?.name;
    },
    setMouseCoordinate(e) {
      var rect = document
        .querySelector('#content-container')
        .getBoundingClientRect();
      this.mouseX = e.clientX - rect.left;
      this.mouseY = e.clientY - (rect.top + rect.height) - 40;
    },
    handleLoad: async function () {
      if (!this.isMounted) return;
      const usStatesArray = this.setUsStatesArrayComputed();
      if (usStatesArray?.[usStatesArray?.length - 1]?.parentNode == null)
        return;
      let regionsData = this.regions || [];
      let inspectedArray = this.inspected;
      let preferredArray = this.preferred;

      let inspectedHash = await inspectedArray.reduce((map, obj) => {
        map[obj.code] = obj;
        return map;
      }, {});
      const usStatesHash = await usStatesArray.reduce((map, obj) => {
        let region = obj.parentNode?.dataset?.name;
        map[obj.classList[2]] = { html: obj, region };
        return map;
      }, {});
      inspectedArray.forEach((el) => {
        usStatesHash?.[el.code]?.html?.classList?.add('observed');
      });
      preferredArray.forEach((el) => {
        if (inspectedHash[el.code] === undefined) {
          usStatesHash?.[el.code]?.html?.classList?.add('preferred');
        } else {
          usStatesHash?.[el.code]?.html?.classList?.add('preferred-observed');
        }
        if (
          !this.preferredByRegion[usStatesHash[el.code]?.region]?.includes(
            el.code
          )
        )
          // eslint-disable-next-line
          this.preferredByRegion[usStatesHash?.[el.code]?.region]?.push(
            el.code
          );
      });
      usStatesArray.forEach((el) => {
        let stateCode = el.classList[2];
        if (!regionsData.includes(usStatesHash[stateCode].region)) {
          el.classList.remove('preferred', 'preferred-observed');
        }
        if (this.firstTime) {
          el.classList.add('state-hovered');
          el.inspectedHash = inspectedHash;
          el.addEventListener('click', this.handleClick);
          el.addEventListener('mouseleave', () => (this.hoveredState = ''));
          el.addEventListener('mouseover', () => {
            this.hoveredState = stateCode;
          });
        } else {
          el.classList.remove('state-hovered');
        }
      });
    },
    setUsStatesArrayComputed() {
      if (this.docQuery) {
        return [
          ...document
            .querySelector('#us_regional_map_by_state')
            .querySelectorAll('.state'),
        ];
      }
    },
  },
};
</script>

<style>
.preferred {
  fill: rgba(248, 198, 23, 0.2) !important;
  stroke: #f8c617 !important;
}

.observed {
  fill: #ededf0 !important;
}

.preferred-observed {
  fill: url('#preferredAndObserved') !important;
  stroke: #f8c617 !important;
}

.state-hovered:hover {
  fill: rgba(247, 247, 250, 1) !important;
  cursor: pointer;
}
.state-tag-container {
  position: absolute;
  /* border: 1px solid red; */
  width: 120px;
  top: calc(var(--mouseY));
  left: calc(var(--mouseX) - 45px);
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
}

.state-tag {
  font-size: 11.75807px;
  padding: 3.5px 7.01px;
  border-radius: 5px;
  color: white;
  background-color: #313545;
}
</style>
